module.exports = __webpack_public_path__ + "static/media/emails-collected.ef01e868.svg";